import { FiGrid, FiGift, FiSettings } from "react-icons/fi";
import { BsBusFront, BsMap } from "react-icons/bs";
import language from "../../language";
import { BiTrip } from "react-icons/bi";
import { FaFileInvoice, FaCity } from "react-icons/fa";
/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
let languageSelectedEnglish =
  sessionStorage.getItem("language") === "english" ||
  !sessionStorage.getItem("language")
    ? true
    : false;

const sidebar = [
  {
    path: "/operator/dashboard", // the url
    icon: FiGrid, // icon
    name: `${languageSelectedEnglish ? "Dashboard" : language.dashboard}`,
  },
  {
    path: "/operator/buses",
    icon: BsBusFront,
    name: `${languageSelectedEnglish ? "Buses" : language.buses}`,
  },
  // {
  //   path: "/operator/cities",
  //   icon: FaCity,
  //   name: `${languageSelectedEnglish ? "Cities" : language.Cities}`,
  // },
  {
    path: "/operator/bus-stations",
    icon: BsMap,
    name: `${languageSelectedEnglish ? "Bus Stations" : language.busStations}`,
  },
  {
    path: "/operator/trips",
    icon: BiTrip,
    name: `${languageSelectedEnglish ? "Trips" : language.trips}`,
  },
  {
    path: "/operator/packages",
    icon: BiTrip,
    name: `${languageSelectedEnglish ? "Packages" : language.trips}`,
  },
  {
    path: "/operator/commissions",
    icon: BiTrip,
    name: `${languageSelectedEnglish ? "Commissions" : language.trips}`,
  },
  {
    path: "/operator/bookings",
    icon: FaFileInvoice,
    name: `${languageSelectedEnglish ? "Bookings" : language.bookings}`,
  },
  {
    path: "/operator/coupons",
    icon: FiGift,
    name: `${languageSelectedEnglish ? "Coupons" : language.coupons}`,
  },
  {
    path: "/operator/profile",
    icon: FiSettings,
    name: `${languageSelectedEnglish ? "Edit Profile" : language.editProfile}`,
  },
];

export default sidebar;
